import HorizontalDivider from "../common/HorizontalDivider";
import { Editbutton } from "@landvoice/icons";

export default function SectionHeader({
  title,
  caption,
  onEditClick,
  className,
}: {
  title: string;
  caption?: string;
  onEditClick?: () => void;
  className?: string;
}) {
  return (
    <div className={`flex gap-4 h-7 items-center   w-full mb-6 ${className || ''}`}>
      <p className="whitespace-nowrap text-sm font-semibold">
        {title}&nbsp;
        {caption && (
          <span className="font-[500] text-[12px] text-gray-secondary">
            {caption}
          </span>
        )}
      </p>
      <HorizontalDivider className="min-w-[25px]" />
      {onEditClick && (
        <div onClick={() => onEditClick()} className="w-[20px] cursor-pointer">
          <Editbutton className="text-[20px] w-5 h-5" />
        </div>
      )}
    </div>
  );
}
